import {
    validate,
    isRequired,
    isEmail,
    isCyrillicFio,
    isMinLength,
    isPhone,
    isInnOrIndividualInn
} from '../../../services/validator';

const registerRules = {
    fio: [
        (val) => isRequired(val, 'Введите ФИО'),
        isCyrillicFio,
        (val) => isMinLength(val, 2),
    ],
    // inn: [
    //     (val) => isRequired(val, 'Введите ИНН'),
    //     (val) => isInnOrIndividualInn(val)
    // ],
    email: [
        (val) => isRequired(val, 'Введите email'),
        isEmail,
    ],
    agreementAccepted: [
        (val) => val && val.length
            ? undefined
            : 'Нам необходимо Ваше согласие',
    ],
    phoneNumber: [
        (val) => isRequired(val, 'Введите телефон'),
        isPhone,
    ],
    activityType: [
        (val) => isRequired(val, 'Выберите вид деятельности')
    ]
    // smscode: process.env.AUTH_PHONE_VERIFY === 'on'
    //     ? [
    //         (val) => isRequired(val, 'Введите код из смс'),
    //         isSmsCode,
    //     ]
    //     : undefined,
    // verified: process.env.AUTH_PHONE_VERIFY === 'on'
    //     ? [
    //         (val) => val === true ? undefined : 'invalid',
    //     ]
    //     : undefined,
};

export function validateRegisterForm(values, verified) {

    if (values.activityType && values.activityType.value == 1) {
        registerRules.companyName = [
            (val) => isRequired(val, 'Введите название организации'),
        ];
        registerRules.orgType = [
            (val) => isRequired(val, 'Выберите форму собственности'),
        ];
    } else {
        registerRules.companyName = null;
        registerRules.orgType = null;
    }

    const errors = validate({
        ...values
    }, registerRules);

    return errors;
}



// WEBPACK FOOTER //
// ./src/modules/sign/Register/validations.js